export enum TabIndexList {
  'ARROW_BACK_BUTTON'        = 0, // ヘッダー: 戻るボタン
  'VIA_BUTTON'               = 0, // 検索画面: 経由ボタン
  'SWITCH_GUIDE_AREA'        = 0, // 検索画面: 発着切り替えボタン
  'OPTION_AIRPOT_BUS'        = 0, // 検索画面: 空港バス優先オプション
  'OPTION_CAR'               = 0, // 検索画面: 自動車オプション
  'OPTION_SHINKANSEN'        = 0, // 検索画面: 新幹線オプション
  'OPTION_LIMITED_EXPRESS'   = 0, // 検索画面: 特急オプション
  'OPTION_IC'                = 0, // 検索画面: ICオプション
  'OPTION_BARRIERFREE'       = 0, // 検索画面: 車椅子オプション
  'COVID19_TIMETEBLE_NOTICE' = 0, // 注意事項: コロナのお知らせボタン
  'TERMS_DIALOG'             = 0, // フッター: 利用規約ボタン
  'SERVICE_ABOUT_DIALOG'     = 0, // フッター: サービス概要ボタン
  'GUIDANCE'                 = 0, // 結果画面: 回避するボタン
  'CHANGE_PUBLIC_MODE'       = 0, // メニュー: Publicモードに遷移させるボタン
  'LINKTIVITY_BUTTON'        = 0, // メニュー: リンクティビティに遷移するボタン
  'ANA_STORE_LINK'           = 0, // その他:   ANAストアリンクボタン
  'TAXI_ROUTE_CHECK'         = 0, // 結果画面: 自動車経路を確認するボタン
  'MK_TAXI_MODAL_BUTTON'     = 0, // その他: MKタクシーモーダルを表示するためのボタン
  'NEARME_MODAL_BUTTON'      = 0, // その他: NearMeモーダルを表示するためのボタン
  'VISA_TOUCH_BANNER'        = 0, // その他: Visaタッチ連携モーダルバナー
  'SHONAI_CAR_SHARE_BANNER'  = 0, // その他: 庄内空港カーシェア連携モーダル
  'JR_EAST_PASS_BANNER'      = 0, // その他: JR EAST PASS連携バナー
  'MK_TAXI_MILE_NOTILE'      = 0, // その他: MKタクシーのマイルに関するご注意の詳細事項を出す
  'OPEN_DETAIL_BUTTON'       = 0, // その他: 詳細開閉ボタン
  'AIRPORTER_OKINAWA'        = 0  // その他: AirporterOkinawaのマイルに関するご注意の詳細事項を出す
}

export const isKeyDownEnter = (e: React.KeyboardEvent, method: (e?: any) => void) => {
  const EnterKeyCode = 13;
  // Enterが押された場合には引数のメソッドを実行する
  if(e.keyCode === EnterKeyCode) {
    method(e);
  }
}
